import styled from 'styled-components';

export const Container = styled.div`
  color: #161d1f;
  padding: 24px;
  background-color: #fff;
  border-radius: 4px;
  margin: 16px 0px 32px 0px;
  width: 100%;
`;
export const ContainerBox = styled.div`
  padding: 10;
  background-color: #ecf4f9;
  border-radius: 5px;
`;

export const ContainerGroup = styled.div`
  margin-top: 4px;
  gap: 40;
  border-radius: 8px;
  padding: 10px;
  background-color: #d5e5f0;
`;

export const ContainerNotesLeft = styled.div`
  flex: 1;
  background-color: #ecf4f9;
  padding: 12px;
  border-radius: 8px;
  gap: 4px;
  margin-right: 12px;
  margin-top: 8px;
  @media (max-width: 600px) {
    margin-right: 0px;
  }
`;
export const ContainerNotes = styled.div`
  flex: 1;
  background-color: #ecf4f9;
  padding: 12px;
  border-radius: 8px;
  margin-top: 8px;
  gap: 4px;
`;
export const ContainerCardNotes = styled.div`
  display: flex;
  margin-top: 8px;
  @media (max-width: 600px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const ContainerModuleName = styled.div`
  flex: 1;
  border-radius: 8px;
  margin: -4px 0px;
  gap: 4px;
`;

export const ImgContainer = styled.img`
  width: fit-content;
  background-color: #e2dffd;
  border: 2px;
  border-radius: 50%;
  padding: 6px;
  margin-right: 4px;
  @media (max-width: 500px) {
    margin-bottom: 16px; /* Ajusta el margen superior según tus necesidades */
  }
`;
